/** sessionStorage key prefix for the per-build reload attempt counter. */
export const CHUNK_LOAD_RELOAD_KEY_PREFIX = "chunk-load-recovery";

/**
 * Reloads allowed per build. One is enough for the case this exists for: a
 * tab holding an old build picks up the new HTML on the first reload. A
 * second attempt would mean the fresh build is also broken, and reloading
 * again just loops.
 */
export const MAX_CHUNK_LOAD_RELOADS_PER_VERSION = 1;
